import { render, staticRenderFns } from "./ModalDialogoBase.vue?vue&type=template&id=acf0cb3e&scoped=true"
import script from "./ModalDialogoBase.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalDialogoBase.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ModalDialogoBase.vue?vue&type=style&index=0&id=acf0cb3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf0cb3e",
  null
  
)

export default component.exports